import { Spin } from 'antd';
import { GaugeChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Config {
  value?: number;
  max?: number;
  label?: string;
  color?: string;
  dataSet?: string;
  xColumn?: string;
  yColumn?: string;
}
interface Data {
  value: number;
  max: number;
}

function GaugeWidget({ instance }: WidgetRenderProps<Config>) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id,
    'gauge',
    instance.config as Record<string, unknown>,
    instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  const value = instance.config.value ?? data?.value ?? 0;
  const max = instance.config.max ?? data?.max ?? 100;
  return (
    <GaugeChart
      value={value}
      max={max}
      label={instance.config.label}
      color={instance.config.color}
    />
  );
}

export const gaugeWidgetDef: WidgetDefinition<Config> = {
  type: 'gauge',
  name: 'Gauge',
  description: 'Progress against a max',
  icon: 'DashboardOutlined',
  category: 'metric',
  defaultTitle: 'Gauge',
  defaultConfig: { value: 50, max: 100 },
  minW: 3,
  minH: 3,
  defaultW: 4,
  defaultH: 4,
  component: GaugeWidget,
  settingsSchema: {
    fields: [
      { key: 'value', label: 'Value', type: 'number' },
      { key: 'max', label: 'Max', type: 'number' },
      { key: 'label', label: 'Label', type: 'text' },
    ],
  },
};
